import { createFileRoute, redirect } from '@tanstack/react-router';

/** Retired tab — cancellation now lives in the single Recurring jobs page (moments 4-5). */
export const Route = createFileRoute('/_dashboard/dashboard/settings/contracts/cancellation')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard/settings/contracts' });
  },
  component: () => null,
});
